import styled from "styled-components";
import { Button } from "@material-ui/core";

import { CrossButtonBlack } from "components/Buttons/CrossButton";
import {MaterialSelector} from "../Selector";

// T2-5839: cap the popup width + center it so Buy Tokens (and the rest of
// the purchase flow dialogs) no longer stretch edge-to-edge on desktop.
export const PopupContainer = styled.div`
  padding: 1.5rem 1rem;
  border-radius: 8px;
  background: white;
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  box-sizing: border-box;
`

export const PopupTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.75rem;
`

export const PopupTitle = styled.div`
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: 1.4;
  font-weight: 600;
`

export const PopupButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const PopupButton = styled(Button)`
  width: 48% !important;
`

export const PopupDescription = styled.div`
  margin: 1.5rem 0;
  line-height: 1.5;
`

export const StyledCrossButtonDark = styled(CrossButtonBlack)`
  top: 0;
  bottom: 0;
  right: 0;
  position: relative;
`

export const Description = styled.div`
  font-size: 1rem;
  margin-bottom: 1.75rem;
  line-height: 1.5;
`

export const InputContainer = styled.div`
  margin-bottom: 0.5rem;
  font-size: 16px;
`

export const StyledMaterialSelector = styled(MaterialSelector)`
  padding-right: 2rem !important;
`

export const ButtonContainer = styled.div`
  margin: 1.5rem 0;
`
